module.exports = __webpack_public_path__ + "img/gallery04.9669a9ab.jpg";